import React from "react";

import { InfoHint } from "../../../components/InfoHint";
import { MANUAL_INVESTMENTS_EXCLUDED_TOOLTIP } from "../constants";

export const ManualInvestmentsHint: React.FC = () => (
  <InfoHint
    title={MANUAL_INVESTMENTS_EXCLUDED_TOOLTIP}
    label={MANUAL_INVESTMENTS_EXCLUDED_TOOLTIP}
    testId="manual-investments-hint"
  />
);
